import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { newsService } from '../../services/newsService';
import NewsCard from '../../components/news/NewsCard';

export default function NewsDetailPage() {
  const { key } = useParams();
  const [article, setArticle] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    setLoading(true);
    setErrorMsg('');

    newsService
      .getNewsByKey(key)
      .then((res) => {
        setArticle(res.data);
      })
      .catch((err) => {
        setErrorMsg(err.message || 'Không tìm thấy bài viết');
      })
      .finally(() => setLoading(false));

    newsService
      .getPublicNews()
      .then((res) => {
        if (res.data) {
          setRelated(res.data.filter((n) => n.key !== key).slice(0, 3));
        }
      })
      .catch(() => {});
  }, [key]);

  if (loading) {
    return (
      <div className="container" style={{ padding: '80px 20px', textAlign: 'center' }}>
        <p className="lead">Đang tải bài viết…</p>
      </div>
    );
  }

  if (errorMsg || !article) {
    return (
      <div className="container" style={{ padding: '80px 20px', textAlign: 'center' }}>
        <h2>Không tìm thấy bài viết</h2>
        <p className="muted" style={{ margin: '16px 0' }}>{errorMsg || 'Bài viết có thể đã bị gỡ hoặc thay đổi đường dẫn.'}</p>
        <Link to="/tin-tuc" className="btn btn--primary">
          ← Về danh sách tin tức
        </Link>
      </div>
    );
  }

  const dateStr = article.published_date
    ? new Date(article.published_date).toLocaleDateString('vi-VN')
    : '';

  return (
    <div>
      <section className="page-hero">
        <div className="container" style={{ maxWidth: '840px' }}>
          <div className="crumb">
            <Link to="/">Trang chủ</Link> / <Link to="/tin-tuc">Tin tức</Link> / <span>{article.category || 'Chi tiết'}</span>
          </div>
          <span className="eyebrow">{article.category || 'Tin tức'}</span>
          <h1>{article.title}</h1>
          <div style={{ display: 'flex', gap: '16px', color: '#64748b', fontSize: '0.95rem', marginTop: '12px' }}>
            {dateStr && <span>Ngày đăng: {dateStr}</span>}
            <span>Thời gian đọc: ~{article.read_minutes || 3} phút</span>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container" style={{ maxWidth: '840px' }}>
          {article.cover_url && (
            <figure style={{ marginBottom: '32px', borderRadius: '12px', overflow: 'hidden' }}>
              <img src={article.cover_url} alt={article.title} style={{ width: '100%', height: 'auto', display: 'block' }} />
            </figure>
          )}

          {article.lead && (
            <p className="lead" style={{ fontWeight: 500, color: '#1d2b24', borderLeft: '4px solid #005b31', paddingLeft: '16px', margin: '24px 0' }}>
              {article.lead}
            </p>
          )}

          <div className="article-body" style={{ fontSize: '1.05rem', lineHeight: 1.8, color: '#334155' }}>
            {article.content ? (
              article.content.split('\n\n').map((para, i) => (
                <p key={i} style={{ marginBottom: '20px' }}>{para}</p>
              ))
            ) : (
              <p>Nội dung chi tiết của bài viết đang được cập nhật thêm.</p>
            )}
          </div>

          <div style={{ marginTop: '48px', paddingTop: '24px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between' }}>
            <Link to="/tin-tuc" className="btn btn--ghost">
              ← Tất cả bài viết
            </Link>
            <Link to="/tuyen-dung" className="btn btn--primary">
              Cơ hội việc làm tại Thế Thảo →
            </Link>
          </div>
        </div>
      </section>

      {related.length > 0 && (
        <section className="section section--soft">
          <div className="container">
            <h3>Bài viết liên quan</h3>
            <div className="news-grid" style={{ marginTop: '24px' }}>
              {related.map((item, idx) => (
                <NewsCard key={item.id} item={item} index={idx} />
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
